// Imports //

// Variables //

const navbarListEl = document.querySelector(".navbar__list"),
  navbarItemsEl = document.querySelectorAll(".navbar__item"),
  navbarToggleEl = document.querySelector(".navbar__toggle");

// Codes //

navbarToggleEl.addEventListener("click", () => {
  navbarListEl.classList.toggle("navbar__toggle--open");
});

if (navbarItemsEl.length > 0) {
  Array.from(navbarItemsEl).forEach((navbarItem) => {
    navbarItem.addEventListener("click", () => {
      navbarListEl.classList.toggle("navbar__toggle--open");
    });
  });
}

const faqQuestionEls = document.querySelectorAll(".faq__question");

if (faqQuestionEls.length > 0) {
  Array.from(faqQuestionEls).forEach(function (faqQuestionEl) {
    faqQuestionEl.addEventListener("click", function () {
      this.nextElementSibling.classList.toggle("faq__show");
      this.classList.toggle("faq__icon-rotate");
    });
  });
}

// Exports //
